import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import html2pdf from "html2pdf.js";

const EstimateDownloadPDF = forwardRef((props, ref) => {
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${today.getFullYear()}`;
    setCurrentDate(formattedDate);
  }, []);

  useImperativeHandle(ref, () => ({
    generatePDF: (htmlContent) => {
      return generatePDF(htmlContent); 
    },
  }));

  const generatePDF = (htmlContent) => {
    return new Promise((resolve, reject) => {
      try {
        const tempDiv = document.createElement("div");
        
        tempDiv.innerHTML = htmlContent;

        const options = {
          filename: `Estimate_${new Date().toISOString().slice(0, 10)}.pdf`,
          image: { type: "png", quality: 1.0 },
          html2canvas: {
            scale: 2,
            scrollX: 0,
            scrollY: 0,
            useCORS: true,
            allowTaint: false,
            letterRendering: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
             
          },
        };

        html2pdf()
          .from(tempDiv)
          .set(options)
          .save()
          .then(() => resolve())
          .catch((err) => {
            console.error("Error generating PDF:", err);
            reject(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  };

  return null; 
});

export default EstimateDownloadPDF;
